import { Component, Input, OnChanges } from '@angular/core';
import { TeamMemberRow } from '../../../interfaces/metrics';

@Component({
  selector: 'bst-team-health-strip',
  templateUrl: './team-health-strip.component.html',
  styleUrls: ['./team-health-strip.component.scss'],
  standalone: false,
})
export class TeamHealthStripComponent implements OnChanges {
  @Input() rows: TeamMemberRow[] | null = null;
  @Input() backlog = 0;
  over = 0; healthy = 0; under = 0; bench = 0; nocap = 0; hours = 0;

  ngOnChanges(): void {
    this.over = this.healthy = this.under = this.bench = this.nocap = 0;
    let seconds = 0;
    for (const r of this.rows ?? []) {
      seconds += r.hours ?? 0;
      const u = r.utilization;
      if (u === null) { this.nocap++; }
      else if (u > 100) { this.over++; }
      else if (u >= 75) { this.healthy++; }
      else if (u >= 50) { this.under++; }
      // Deliberately NOT called "benched": this bucket is purely "billable utilization
      // under 50% this period", which on a Monday morning also catches actively assigned
      // members who have not logged hours yet. The roster next to this strip stopped
      // inferring bench from utilization for exactly that reason; the label here says what
      // is actually measured instead. A true bench signal needs assignment state, which
      // the roster payload does not carry today.
      else { this.bench++; }
    }
    // Team hours = Σ member hours (already rounded per member), computed from the
    // same live roster as the counts so the strip never drifts from the bars.
    this.hours = Math.round(seconds * 10) / 10;
  }
}
